import type {
  ContractImportJobsQueryParams,
  PaginatedContractImportJobsResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  zodContractImportJobsQueryParamsSchema,
  zodPaginatedContractImportJobsResponseSchema,
} from './validations';

/**
 * Fetches the current user's contract import jobs from the API.
 *
 * @param queryParams - The query parameters for fetching import jobs.
 * @param options - Additional request options.
 * @returns The paginated import job data.
 * @throws VestigasHTTPError if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Contract-Import-Jobs/operation/list_import_jobs_contracts_import_jobs_get
 */
export const fetchContractImportJobs = async (
  queryParams: Partial<ContractImportJobsQueryParams>,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.CONTRACT_IMPORT_JOB.GET_ALL(), {
      searchParams: queryParams,
      validate: {
        response: zodPaginatedContractImportJobsResponseSchema,
        searchParams: zodContractImportJobsQueryParamsSchema.transform((data) =>
          withoutObjectKeysWhereValueIs(data, [undefined]),
        ),
      },
      ...options,
    })
    .json<PaginatedContractImportJobsResponse>();
